import React, { useState } from "react";
import { Modal, ModalBody, Button, Tooltip } from "reactstrap";
import Reason from "../../common/utilities/Reason/Reason";

/* ---------- Types ---------- */

interface DeleteModalProps {
  isopen?: boolean;
  recordId?: number | null;
  recordName?: string;
  toggle?: () => void;
  onDeleteClick?: (payload: { id: number | null; reason: string }) => void;
  isLoading?: boolean;
  show?: boolean;
  onCloseClick?: () => void;
  showDeleteReason?: boolean;
  toggleDeleteReason?: () => void;
}

/* ---------- Component ---------- */

const DeleteModal: React.FC<DeleteModalProps> = ({
  isopen,
  recordId,
  recordName,
  toggle,
  onDeleteClick,
  isLoading = false,
  showDeleteReason = false,
  toggleDeleteReason,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggleTooltip = () => setTooltipOpen((prev) => !prev);

  const handleConfirmDeactivate = (): void => {
    toggleDeleteReason?.();
  };

  const handleReasonSubmit = (payload: {
    id: number | null;
    reason: string;
  }): void => {
    onDeleteClick?.(payload);
  };

  return (
    <>
      {/* Deactivate Confirmation Modal */}
      <Modal fade isOpen={isopen} toggle={toggle} centered backdrop={"static"}>
        <ModalBody className="py-3 px-5">
          <div className="mt-2 text-center">
            <i className="ri-forbid-line display-5 text-warning"></i>
            <div className="pt-2 fs-15 mx-4 mx-sm-5">
              <h4>Are you sure?</h4>
              <p className="text-muted mb-0">
                Are you sure you want to deactive this record
              </p>

              {/* Record name with truncation + tooltip */}
              {recordName && (
                <>
                  <div className="d-flex justify-content-center align-items-center">
                    <strong
                      id="recordNameTooltipTarget"
                      style={{
                        display: "block",
                        maxWidth: "max-content",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                        marginTop: "4px",
                      }}
                      title={recordName}
                    >
                      {recordName}
                    </strong>
                  </div>
                  <Tooltip
                    isOpen={tooltipOpen}
                    target="recordNameTooltipTarget"
                    toggle={toggleTooltip}
                    placement="top"
                  >
                    {recordName}
                  </Tooltip>
                </>
              )}
            </div>
          </div>

          <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
            <Button
              onClick={toggle}
              outline
              color="light"
              className="w-sm"
              type="button"
            >
              Cancel
            </Button>
            <Button
              type="button"
              className="btn w-sm btn-warning"
              onClick={handleConfirmDeactivate}
            >
              Yes, Deactive It!
            </Button>
          </div>
        </ModalBody>
      </Modal>

      {/* Reason Modal */}
      <Reason
        isOpen={showDeleteReason}
        toggle={() => toggleDeleteReason?.()}
        action="Deactivate"
        id={recordId}
        click={handleReasonSubmit}
        isLoading={isLoading}
      />
    </>
  );
};

export default DeleteModal;
